import { useIntl } from 'react-intl'
import { LuxButton } from '@lux/wardrobe-lib'
import './VisitActionCard.scss'
import { ProjectApiSurvey } from '@/app/models/projects-service'
import { SectionFilter } from '@/app/models/search'

export interface VisitActionCardProps {
    survey: ProjectApiSurvey
    progress: number
    showStatusDisclaimer: boolean
    onOpenSurvey: (survey: ProjectApiSurvey) => void
    onOpenTask: (id: string) => void
}

const VisitActionCard = (props: VisitActionCardProps) => {
    const { progress, survey, showStatusDisclaimer, onOpenSurvey, onOpenTask } = props

    const componentClass = 'smart-modals-visit-action-card'

    const intl = useIntl()

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__bar`}>
                <div
                    data-progress={progress}
                    style={{ width: `${progress > 0 ? progress : 0}%` }}
                    className={`${componentClass}__bar__progress`}
                />
            </div>
            {showStatusDisclaimer && (
                <div className="text">
                    {intl.formatMessage({
                        id: 'survey.status.request',
                        defaultMessage: 'Please wait, status update in progress...',
                    })}
                </div>
            )}
            <div className={`${componentClass}__row`}>
                <div className={`${componentClass}__title text-bold`}>{survey.surveyName}</div>

                <div className={`${componentClass}__button`}>
                    <LuxButton
                        variant={'outlined'}
                        onClick={onOpenSurvey.bind(null, survey)}
                        text={intl.formatMessage({
                            id: 'modals.news_execution.action.surveys.open_survey',
                            defaultMessage: 'Open Survey',
                        })}
                    />
                </div>
            </div>
            {survey.surveyTaskList?.map((task) => (
                <div className={`${componentClass}__row`}>
                    <div className={`${componentClass}__title`}>
                        <div className="text-bold">{task.projectTitle}</div>
                        <div className="text-mini">
                            {intl.formatMessage({
                                id: `modals.news_execution.action.action_card.status.${
                                    task.status === SectionFilter.closed
                                        ? 'completed'
                                        : 'not_completed'
                                }`,
                                defaultMessage: task.status,
                            })}
                        </div>
                    </div>

                    <div className={`${componentClass}__button`}>
                        <LuxButton
                            variant={'outlined'}
                            onClick={onOpenTask.bind(null, task.id)}
                            text={intl.formatMessage({
                                id: 'modals.activity.visit.action.surveys.open.task',
                                defaultMessage: 'Open Survey Task',
                            })}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default VisitActionCard
